import TabItem from "./presentational";
export default TabItem;
